require('bootstrap');
import axios from 'axios'
import { fabric } from "fabric";
import FontFaceObserver from "fontfaceobserver";
import VanillaQR from "VanillaQR";

var canvas;
//console.log(frame)
var canvas_w = template.width;
var canvas_h = template.height;

var clip_w = template.clip_w;
var clip_h = template.clip_h;
var clip_x = template.clip_x;
var clip_y = template.clip_y;

var save_action = null;
var current_image = null
var current_image_width = null

var delay = (function(){
    var timers = {};
    return function (callback, ms, label) {
        label = label || 'defaultTimer';
        clearTimeout(timers[label] || 0);
        timers[label] = setTimeout(callback, ms);
    };
})();

function init_actions() {
    var saveDownload = document.getElementById('crafty-save-download');
    saveDownload.addEventListener('click', function(e){
        save_download()
    });
    $('.crafty-save-download').click(function(){
        save_download($(this).val());
    });

    window.addEventListener('resize',function(){
        resize_canvas();
    })

    $('.frame-text-input').each(function(){
        count_char($(this));
    });

    $('.frame-text-input').on('keyup change',function(){
        var $this = $(this);
        delay(function(){
            count_char($this);
            update_texts();
        },300)
    });

    $('#crafty-image-size').on('change',function(){
        var scale = $(this).val()/100;
        console.log(current_image)
        var new_w = Math.round( current_image_width * scale);
        current_image.scaleToWidth(new_w);
        canvas.renderAll();
    });
}

function save_download(redirect) {
    let email = document.getElementById('crafty-user-email');
    if(!email.value && required_email) {
        alert('กรุณากรอกอีเมลล์');
        return;
    }
    showLoading();
    var json = canvas.toJSON();
    //var svg = canvas.toSVG();
    var image_data = canvas.toDataURL({format:'jpeg'});
    var form = document.querySelector('#crafty-form');
    var data = new FormData(form);

    data.forEach((e,k)=>{
        console.log(k,e)
    })
    if(redirect) {
        data.append('redirect',redirect);
    }
    //data.append('json',JSON.stringify(json));
    data.append('data',image_data);

    if(current_image) {
        data.append('img_scale',current_image.scaleX)
        data.append('img_x',current_image.left??0)
        data.append('img_y',current_image.top??0)
    }
    axios({
        url: save_url,
        method: 'POST',
        headers: {"Content-Type": "multipart/form-data"},
        data: data
    }).then((res) => {
        hideLoading();
        if(res && res.data && res.data.success===1) {
            //window.open('/create/view/'+res.data.uniq);
            window.location = res.data.redirect
        } else {
            alert('Error saving image');
        }
    }).catch(function (error) {
        alert('Error download image');
        hideLoading();
    })
}

function download() {
    var link = document.createElement('a')
    link.href = canvas.toDataURL({
        format: 'jpeg',
        quality: 0.9
    }).replace("image/jpeg", "image/octet-stream");
    link.download = 'grab_create.jpg'
    link.target = "_blank"
    setTimeout(function() {
        link.click();
        // Cleanup the DOM
        document.body.removeChild(link);
    }, 500);
}

function resize_canvas() {
    var product_container = document.getElementById('crafty-frame-container');
    product_container.style.width = canvas_w+"px";
    product_container.style.height = canvas_h+"px";

    var editor = document.getElementById('crafty-frame-wrapper');
    var editor_width = editor.offsetWidth;

    var editor_scale = Math.round((editor_width * 100) / canvas_w)/100;
    var container = document.getElementById('crafty-frame-container');

    if (editor_width <= canvas_w) {
        container.style.transform = "scale("+ editor_scale + ")";
    }
    $('#crafty-frame-wrapper').height((canvas_h*editor_scale)+'px');
}

function init_canvas() {
    resize_canvas();
    var options = {
        width: canvas_w, height: canvas_h,
        preserveObjectStacking: true,
        controlsAboveOverlay: true,
        selection: false,
        backgroundColor: 'white'
    }

    canvas = new fabric.Canvas('crafty-frame-canvas', options);
    addFrame(template.frame_image);
    if(template.uploaded_image) {
        addImage(template.uploaded_image,true);
    }
}
function init_uploader() {
    document.getElementById('fileupload_input').onchange = function handleImage(e) {
        if(e.target && e.target.files.length > 0) {
            const file = e.target.files[0];

            // Validate if the file is an image
            if (!file.type.startsWith('image/')) {
                alert("Please select a valid image file (JPG, JPEG, PNG, GIF, BMP, SVG, WEBP)");
                e.target.value = ''; // Clear the file input
                return;
            }

            var reader = new FileReader();
            reader.onload = function (event){
                var imgObj = new Image();
                imgObj.src = event.target.result;
                addImage(imgObj.src);
            }
            reader.readAsDataURL(file);
        }
    }

    var images = document.getElementsByClassName('fileupload_input')
    for (var i = 0; i < images.length; i++) {
        images[i].onchange = function handleImage(e) {
            if(e.target && e.target.files.length > 0) {
                const file = e.target.files[0];

                // Validate if the file is an image
                if (!file.type.startsWith('image/')) {
                    alert("Please select a valid image file (JPG, JPEG, PNG, GIF, BMP, SVG, WEBP)");
                    e.target.value = ''; // Clear the file input
                    return;
                }

                var reader = new FileReader();
                reader.onload = function (event){
                    var imgObj = new Image();
                    imgObj.src = event.target.result;
                    addExtraImage(imgObj.src,getObjIndexFromHandle(e.target.dataset.handle),false);
                }
                reader.readAsDataURL(file);
            }
        }
    }
}

/*
function init_uploader() {

    document.getElementById('fileupload_input').onchange = function handleImage(e) {
        var reader = new FileReader();
        reader.onload = function (event){
            var imgObj = new Image();
            imgObj.src = event.target.result;
            addImage(imgObj.src);
        }
        if(e.target && e.target.files.length>0) {
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    var images = document.getElementsByClassName('fileupload_input')
    for (var i = 0; i < images.length; i++) {
        images[i].onchange = function handleImage(e) {
            var reader = new FileReader();
            reader.onload = function (event){
                var imgObj = new Image();
                imgObj.src = event.target.result;
                addExtraImage(imgObj.src,getObjIndexFromHandle(e.target.dataset.handle),false);
            }
            if(e.target && e.target.files.length>0) {
                reader.readAsDataURL(e.target.files[0]);
            }
        }
    }
}
*/

function getObjIndexFromHandle(handle) {
    var res = null
    for(var i=0;i<template.objects.length;i++) {
        if(template.objects[i].handle===handle)res = i
    }
    return res
}

function init_texts() {
    var font1 = new FontFaceObserver('Grab Community Solid WF', { weight: 700 });
    var font2 = new FontFaceObserver('Grab Community Solid WF', { weight: 400 });
    var font3 = new FontFaceObserver('Grab Community Inline WF', { weight: 700 });
    Promise.all([
        font1.load(),
        font2.load(),
        font3.load()
    ]).then(function () {
        //console.log(template)
        for(var i=0;i<template.objects.length;i++) {
            var item = template.objects[i];
            var obj;
            if(item.status==1) {
                if(item.type==='text') {
                    obj = new fabric.IText(item.text, {
                        fontSize: item.font_size,
                        fontFamily: item.font_family,
                        fontWeight: item.font_weight,
                        top: item.pos_y,
                        left: item.pos_x,
                        selectable: false,
                        evented: false,
                        fill: item.text_color,
                        shadow: item.shadow_color+" "+item.shadow,
                        lineHeight: 1.1
                    });
                    canvas.add(obj);
                    obj.bringToFront();
                    template.objects[i].obj = obj;
                }else if(item.type==='qr') {
                    generateQR(item.default,item,i)
                }else if(item.type==='image') {
                    // console.log(item)
                    if(template && template.extra_images && template.extra_images[item.handle]){
                        addExtraImage(template.extra_images[item.handle],i,false)
                    } else {
                        addExtraImage(item.ex_image??item.text,i,true)
                    }
                }
            }
        }
        update_texts()
    });
}

function count_char($item) {
    var count = $('#craft-count-'+$item.data('handle'))
    if(count && $item.attr('maxlength')) {
        count.text($item.val().length+'/'+$item.attr('maxlength'));
    }
}

function update_texts() {
    var values = []

    for(var i=0;i<template.objects.length;i++) {
        var obj = template.objects[i];
        if(obj.status) {
            var changed_text = obj.text;
            $('.frame-text-input').each(function(){
                var val = $(this).val()
                var handle = $(this).data('handle')
                if(changed_text) {
                    changed_text = changed_text.replace('{#'+handle+'}', val)
                }
            });
            if(changed_text !== obj.current_text) {
                obj.current_text = changed_text;
                if(obj.type==='text') {
                    obj.obj.set('text',changed_text);
                    canvas.renderAll();
                    if(obj.text_align==='right') {
                        var left = (obj.width-obj.obj.width) + obj.pos_x;
                        obj.obj.set('left', left);
                        canvas.renderAll();
                    }
                    if(obj.text_align==='center') {
                        var left =  obj.pos_x+((obj.width-obj.obj.width)/2);
                        obj.obj.set('left', left);
                        canvas.renderAll();
                    }
                    while (obj.obj.width > obj.width && obj.obj.fontSize > 12) {
                        obj.obj.fontSize--;
                        canvas.renderAll();
                    }
                    while (obj.obj.width < obj.width && obj.obj.fontSize < obj.size) {
                        obj.obj.fontSize++;
                        canvas.renderAll();
                    }

                    let lines = [];
                    if(changed_text)changed_text.split(/\r\n|\r|\n/g);
                    if(lines.length>1) {
                        let top = obj.pos_y - ((obj.obj.height/2)/2);
                        obj.obj.set('top', top);
                    } else {
                        obj.obj.set('top', obj.pos_y);
                    }
                    /*
                    if( changed_text )
                    console.log(obj.obj.height)
                    */

                }else if(obj.type==='qr') {
                    generateQR(encodeURI(changed_text),obj,i)
                }
            }
        }
    }
}

// insert image into canvas after upload
function addFrame(filepath) {
    var image = filepath;
    fabric.Image.fromURL(image, function (oImg) {
        oImg.set({
            selectable: false,
            hasControls: false,
            hasBorders: false,
            evented: false
        });

        var imgWidth = oImg.width;
        var imgHeight = oImg.height;
        var wRatio = canvas_w / imgWidth
        var hRatio = canvas_h / imgHeight
        if( wRatio < hRatio ){
            oImg.scaleToHeight(canvas_h);
        }else{
            oImg.scaleToWidth(canvas_w);
        }

        canvas.add(oImg);
        canvas.centerObject(oImg);
        oImg.sendToBack();
        if(current_image)current_image.sendToBack();
    },{crossOrigin: 'anonymous'});
}

// insert image into canvas after upload
function addImage(filepath,init) {
    var image = filepath;
    showLoading();
    fabric.Image.fromURL(image, function (oImg) {
        clearImage();
        var imgWidth = oImg.width;
        var imgHeight = oImg.height;
        oImg.set({
            hasBorders: false,
            hasControls: false,
            originX: "center",
            originY: "center"
        });
        canvas.add(oImg);
        if(init && template.img_scale && template.img_x) {
            //console.log(template)
            oImg.scale(template.img_scale);
            oImg.set({
                scaleX: template.img_scale,
                scaleY: template.img_scale,
                top: template.img_y,
                left: template.img_x,
                originX: "left",
                originY: "top"
            });
            //canvas.centerObject(oImg);
        } else {
            var wRatio = clip_w / imgWidth
            var hRatio = clip_h / imgHeight
            if( wRatio < hRatio ){
                oImg.scaleToHeight(clip_h);
            }else{
                oImg.scaleToWidth(clip_w);
            }
            //console.log(clip_y-((imgH-clip_h) / 2))
            let imgW = oImg.width*oImg.scaleX
            let imgH = oImg.height*oImg.scaleY
            oImg.set({
                originX: "left",
                originY: "top",
                top: clip_y-((imgH-clip_h) / 2),
                left: clip_x-((imgW-clip_w) / 2)
            })
            //canvas.centerObject(oImg);
        }
        oImg.clipPath = new fabric.Rect({
            width: clip_w,
            height: clip_h,
            top: clip_y,
            left: clip_x,
            originX: "left",
            originY: "top",
            absolutePositioned: true
        })
        oImg.sendToBack();
        current_image = oImg
        current_image_width = oImg.getScaledWidth()
        $('#crafty-fileupload').hide()
        $('#crafty-image-tools').show()
        hideLoading();
    },{crossOrigin: 'anonymous'});
}

// insert image into canvas after upload
function addExtraImage(filepath,index,init) {
    // console.log(addExtraImage)
    var item = template.objects[index];
    var image = filepath;
    showLoading();
    fabric.Image.fromURL(image, function (oImg) {
        // clearImage();
        var posx = item.pos_x??0;
        var posy = item.pos_y??0;

        let scale_x = item.width/oImg.width
        let scale_y = item.height/oImg.height
        let the_scale = (scale_x<scale_y)?scale_x:scale_y;

        if(template.objects[index].obj)
        {
            posx = template.objects[index].obj.left;
            posy = template.objects[index].obj.top;
            canvas.remove(template.objects[index].obj)
        } else {
            posx = posx + (item.width/2);
            posy = posy + (item.height/2);
        }

        oImg.set({
            hasBorders: false,
            hasControls: false,
            evented: false,
            originX: "center",
            originY: "center",
            left: posx,
            top: posy
        });

        if(init)
        {
            oImg.set({
                scaleX: the_scale,
                scaleY: the_scale
            })
        } else {
            if(scale_x<scale_y) {
                oImg.scaleToWidth(item.width);
            } else {
                oImg.scaleToHeight(item.height);
            }
        }
        // oImg.setControlsVisibility({ mtr: false })
        canvas.add(oImg);
        canvas.renderAll();
        template.objects[index].obj = oImg;
        reIndex();
        /*
        if(init && template.img_scale && template.img_x) {
            //console.log(template)
            oImg.scale(template.img_scale);
            oImg.set({
                scaleX: template.img_scale,
                scaleY: template.img_scale,
                top: template.img_y,
                left: template.img_x,
                originX: "left",
                originY: "top"
            });
            //canvas.centerObject(oImg);
        } else {
            var wRatio = clip_w / imgWidth
            var hRatio = clip_h / imgHeight
            if( wRatio < hRatio ){
                oImg.scaleToHeight(clip_h);
            }else{
                oImg.scaleToWidth(clip_w);
            }
            //console.log(clip_y-((imgH-clip_h) / 2))
            let imgW = oImg.width*oImg.scaleX
            let imgH = oImg.height*oImg.scaleY
            oImg.set({
                originX: "left",
                originY: "top",
                top: clip_y-((imgH-clip_h) / 2),
                left: clip_x-((imgW-clip_w) / 2)
            })
            //canvas.centerObject(oImg);
        }
        */
        // current_image = oImg
        // current_image_width = oImg.getScaledWidth()
        hideLoading();
    },{crossOrigin: 'anonymous'});
}

function reIndex() {
    // console.log(template)
    for(var i=0;i<template.objects.length;i++) {
        // var item = this.frames[i]
        if(template.objects[i].obj) {
            // console.log(template.objects[index])
            canvas.bringToFront(template.objects[i].obj)
        }
    }
}

function clearImage() {
    canvas.remove(current_image);
    current_image = null
    $('#crafty-fileupload').show()
    $('#crafty-image-tools').hide()
    $('#crafty-image-size').val(100)
}

function generateQR(text,item,index) {
    var qr = new VanillaQR({
        url: text,
        width: item.width,
        height: item.width,
        colorLight: "#FFFFFF",
        colorDark: item.color,
        ecclevel: 1,
        noBorder: true
    });
    if(template.objects[index].obj) {
        canvas.remove(template.objects[index].obj);
    }
    var qrimg = qr.domElement.toDataURL('svg+xml')
    fabric.Image.fromURL(qrimg, function(loadedObject, options) {
        loadedObject.set({
            left: item.pos_x,
            top: item.pos_y,
            selectable: false,
            evented: false,
            paintFirst: 'stroke',
            stroke : 'white',
            strokeWidth: 0
        });
        loadedObject.scaleToWidth(item.width);
        canvas.add(loadedObject);
        template.objects[index].obj = loadedObject;
    });
}

function showLoading() {
    $('#global-loading').addClass('active');
    $('.preloader').show();
}

function hideLoading() {
   $('#global-loading').removeClass('active');
   $('.preloader').hide();
}

$(document).ready(function(){
    init_canvas();
    init_uploader();
    init_actions();
    init_texts();
});
